import { DataTable } from "@/shared/ui/data-table.tsx"
import SummaryGrid from "./components/summary/SummaryGrid"
import { AnalyticsColumn as columns } from "./components/analytics-table/AnalyticsColumn"

const posts = [
  {
    post_id: 1,
    event_name: "Holiday Giveaway",
    event_type: "Campaign",
    likes: 1200,
    views: 15000,
    date_posted: "2024-12-01",
  },
  {
    post_id: 2,
    event_name: "New Year Celebration",
    event_type: "Post",
    likes: 980,
    views: 10200,
    date_posted: "2024-12-10",
  },
  {
    post_id: 3,
    event_name: "Product Launch",
    event_type: "Campaign",
    likes: 3000,
    views: 45000,
    date_posted: "2024-11-25",
  },
  {
    post_id: 4,
    event_name: "Weekly Highlights",
    event_type: "Post",
    likes: 520,
    views: 7300,
    date_posted: "2024-12-07",
  },
  {
    post_id: 5,
    event_name: "Black Friday Sale",
    event_type: "Campaign",
    likes: 8500,
    views: 100000,
    date_posted: "2024-11-24",
  },
  {
    post_id: 6,
    event_name: "Summer Trends",
    event_type: "Post",
    likes: 700,
    views: 8200,
    date_posted: "2024-07-15",
  },
  {
    post_id: 7,
    event_name: "Back to School",
    event_type: "Campaign",
    likes: 2300,
    views: 34000,
    date_posted: "2024-08-10",
  },
  {
    post_id: 8,
    event_name: "Spring Collection Preview",
    event_type: "Post",
    likes: 620,
    views: 7800,
    date_posted: "2024-03-05",
  },
  {
    post_id: 9,
    event_name: "Charity Fundraiser",
    event_type: "Campaign",
    likes: 4100,
    views: 52000,
    date_posted: "2024-10-20",
  },
  {
    post_id: 10,
    event_name: "Employee Spotlight",
    event_type: "Post",
    likes: 300,
    views: 4500,
    date_posted: "2024-11-12",
  },
  {
    post_id: 11,
    event_name: "Customer Appreciation Day",
    event_type: "Campaign",
    likes: 1900,
    views: 22000,
    date_posted: "2024-09-15",
  },
  {
    post_id: 12,
    event_name: "Weekly Recipe",
    event_type: "Post",
    likes: 400,
    views: 5600,
    date_posted: "2024-06-01",
  },
  {
    post_id: 13,
    event_name: "Fall Fashion Showcase",
    event_type: "Campaign",
    likes: 3700,
    views: 41000,
    date_posted: "2024-10-05",
  },
  {
    post_id: 14,
    event_name: "Throwback Thursday",
    event_type: "Post",
    likes: 480,
    views: 6100,
    date_posted: "2024-11-28",
  },
  {
    post_id: 15,
    event_name: "End of Year Sale",
    event_type: "Campaign",
    likes: 7200,
    views: 92000,
    date_posted: "2024-12-15",
  },
];

const AnalyticsView = () => {
  return (
    <div className="mt-[5vh] w-full h-[95vh] overflow-auto">
      {/*for header*/}
      <div className="w-full py-10 md:py-24 flex justify-center items-center">
        <h1 className="font-montserrat text-4xl font-[500]">Post Analytics</h1>
      </div>
      <SummaryGrid />
      <div className="px-5 md:px-16 py-8 mt-5">
        <DataTable columns={columns} data={posts} />
      </div>
    </div>
  )
}

export default AnalyticsView
